export const whatIsCabelServer = [
  {
    id: "159.146.191.67",
    type: "custom",
    position: { x: 725, y: 170 },
    dragHandle: "noDrag",
    className: "server non-draggable",
    data: { label: "159.146.191.67" },
  },
  {
    id: "17.246.37.189",
    type: "input",
    dragHandle: "noDrag",
    position: { x: 725, y: 370 },
    className: "server non-draggable",
    data: { label: "17.246.37.189" },
  },
];
